module.exports = __webpack_public_path__ + "img/home-soccer-icon-red.3ee66e4c.png";